/**
 * CodeTable Component
 * 그룹 내 공통코드 목록 테이블
 */
import React from 'react';
import { CommonCodeItem } from '../types/systemCommonCode.types';
import {
    CODE_TABLE_HEADERS,
    EMPTY_MESSAGES,
    getUseYnLabel,
    getUseYnClassName,
    displayValue,
} from './commonCodeManagement.helpers';

// ======== 타입 ========

interface CodeTableProps {
    codes: CommonCodeItem[];
}

// ======== 컴포넌트 ========

const CodeTable: React.FC<CodeTableProps> = ({ codes }) => {
    return (
        <div className="group-codes-content">
            <div className="table-wrapper-inline">
                <table className="code-table-inline">
                    <thead>
                    <tr>
                        {CODE_TABLE_HEADERS.map((header) => (
                            <th key={header}>{header}</th>
                        ))}
                    </tr>
                    </thead>
                    <tbody>
                    {codes.length === 0 ? (
                        <tr>
                            <td colSpan={CODE_TABLE_HEADERS.length} className="empty-row">
                                {EMPTY_MESSAGES.NO_CODES}
                            </td>
                        </tr>
                    ) : (
                        codes.map((code) => (
                            <tr key={code.comCode}>
                                <td className="code-cell">
                                    <span className="code-value">{code.comCode}</span>
                                </td>
                                <td className="name-cell">{code.comCdName}</td>
                                <td className="status-cell">
                                        <span className={`status-badge ${getUseYnClassName(code.useYn)}`}>
                                            {getUseYnLabel(code.useYn)}
                                        </span>
                                </td>
                                <td className="value-cell">{displayValue(code.val1)}</td>
                                <td className="value-cell">{displayValue(code.val2)}</td>
                                <td className="value-cell">{displayValue(code.val3)}</td>
                                <td className="value-cell">{displayValue(code.val4)}</td>
                                <td className="value-cell">{displayValue(code.val5)}</td>
                            </tr>
                        ))
                    )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default CodeTable;
